export default __webpack_public_path__ + "static/insurance-banner-ece8a40eb997fccb1567d987ed467f19.webp";